import React from 'react';
import { Grid, Typography } from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

type DividerProps = {
  color?: string | null;
  m?: number | string | null;
  mt?: number | string | null;
  mb?: number | string | null;
  mr?: number | string | null;
  ml?: number | string | null;
  fontColor?: string | null;
  children?: React.ReactNode;
};
const useStyles = makeStyles(theme => ({
  divider: ({ color = '#cccccc' }: any) => ({
    height: 1,
    width: '95%',
    backgroundColor: color,
    marginTop: 10,
  }),
  container: ({ m, mt, mb, mr, ml }: any) => ({
    margin: m,
    marginTop: mt,
    marginBottom: mb,
    marginRight: mr,
    marginLeft: ml,
  }),
  font: ({ fontColor, fontSize, textTransform = 'none' }: any) => ({
    color: fontColor,
    fontSize,
    textTransform,
  }),
}));

const DividerWithText: React.FC<DividerProps> = (props: DividerProps) => {
  const classes = useStyles(props);
  return (
    <div className={classes.container}>
      <Grid container spacing={0}>
        <Grid item xl={1} lg={1} md={1} sm={1} xs={1}>
          <div className={classes.divider} />
        </Grid>
        <Typography className={classes.font}>{props.children}</Typography>
        <Grid item xl lg md sm xs>
          <div className={classes.divider} />
        </Grid>
      </Grid>
    </div>
  );
};

export default DividerWithText;
